import { DotsSixVertical, X } from '@phosphor-icons/react';
import styled from 'styled-components';
import { useDrag } from 'react-dnd';
import { ItemImage } from '../../../components';
import { HoverBorderButton, MuteText } from '../../../elements';
import { ItemTypes } from '../../zones/common';

const TitleContainer = styled.span`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 300px;
`;

const ItemContainer = styled.div`
  cursor: grab;
  &.is-dragging {
    cursor: grabbing;
    opacity: 0;
  }
`;

export function DraggableItem({ item, unPackItem, packageIndex }) {
  const [{ isDragging }, drag] = useDrag(
    () => ({
      type: ItemTypes.packageItem,
      item: () => ({ _id: item._id, ...item, packageIndex }),
      collect: monitor => ({
        isDragging: !!monitor.isDragging(),
      }),
      isDragging: monitor => monitor.getItem()._id === item._id,
    }),
    [item, packageIndex],
  );

  return (
    <ItemContainer
      ref={drag}
      key={item._id}
      className={`${
        isDragging ? 'is-dragging' : ''
      } d-flex align-items-center justify-content-between`}
    >
      <div className="d-flex align-items-center">
        <DotsSixVertical size={20} />
        <ItemImage
          imageKey="p_images"
          displayImageKey="display_image"
          item={item?.productId}
          size="mini"
        />
        <div className="d-flex flex-column ml-2">
          <TitleContainer>{item?.productId?.p_title}</TitleContainer>
          <div className="d-flex">
            <MuteText>SKU</MuteText>
            <span className="ml-2">{item?.productId?.p_sku}</span>
          </div>
          <div className="d-flex">
            <MuteText>UPC</MuteText>
            <span className="ml-2">{item?.productId?.upc}</span>
          </div>
        </div>
      </div>
      <HoverBorderButton
        onClick={() => unPackItem(item)}
        size="mini"
        className="flex-btn p-2"
      >
        <X size={17} />
      </HoverBorderButton>
    </ItemContainer>
  );
}

export function ReadOnlyItem({ item }) {
  return (
    <div key={item._id} className="d-flex align-items-center justify-content-between">
      <div className="d-flex align-items-center">
        <ItemImage
          imageKey="p_images"
          displayImageKey="display_image"
          item={item?.productId}
          size="mini"
        />
        <div className="d-flex flex-column ml-2">
          <TitleContainer>{item?.productId?.p_title}</TitleContainer>
          <div className="d-flex">
            <MuteText>SKU</MuteText>
            <span className="ml-2">{item?.productId?.p_sku}</span>
          </div>
          <div className="d-flex">
            <MuteText>UPC</MuteText>
            <span className="ml-2">{item?.productId?.upc}</span>
          </div>
        </div>
      </div>
    </div>
  );
}
